import React, { useMemo } from 'react';

import { useAuth } from './AuthorizationProvider';
import { useConfig } from './ConfigurationProvider';
import { createAuthHeaders, createAxiosClient, updateAuthHeaders } from '../utils/keycloakUtils';
import { dataProviderStateMock } from '../utils/test/dataProviderMock';

const DataProviderContext = React.createContext(dataProviderStateMock);

export const DataProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { tenant } = useConfig();

  const authContext = useAuth();
  if (!authContext) throw new Error('DataProviderContext has to be used inside auth context!');

  // create client only once
  const client = useMemo(() => {
    return createAxiosClient(authContext.keycloak.token!, tenant);

    // TODO 11. 3. 2022 (david.salamon) -> Implement abort logic here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // just update headers later on
  const value = {
    client: updateAuthHeaders(client, createAuthHeaders(authContext.keycloak.token!, tenant)),
  };

  return <DataProviderContext.Provider value={value}>{children}</DataProviderContext.Provider>;
};

export const DataProviderConsumer = DataProviderContext.Consumer;

export const useDataProvider = () => React.useContext(DataProviderContext);
